import React, {useEffect, useState} from 'react';
import Http from "../../http";
import {Message, BULMA} from "@graffer-inc/graffer-ui";
import moment from 'moment';

const Main = () => {
  const [opsNotification, setOpsNotification] = useState(null);
  useEffect(() => {
    const fetchOpsNotification = async () => {
      await Http.fetchOpsNotification(
        res => {
          const fetched = res.data.opsNotification;
          if (!fetched) {
            return;
          }
          if (fetched.isDeleted) {
            return;
          }
          if (moment().isBefore(moment(fetched.startAt)) || moment().isAfter(moment(fetched.endAt))) {
            return;
          }
          setOpsNotification(fetched);
        },
        () => {
          // do nothing.
        }
      );
    };
    fetchOpsNotification();
  }, []);
  if (!opsNotification) {
    return null;
  }
  return (
    <Message color={BULMA.COLOR.WARNING}>
      <nav className="level" style={{marginBottom: '12px'}}>
        <div className="level-left">
          <div className="level-item">
            <p className="has-text-weight-bold">{opsNotification.title}</p>
          </div>
        </div>
      </nav>
      {opsNotification.message.split("\n").map((s) => (
        <span key={s}>
          {s}<br/>
        </span>
      ))}
    </Message>
  );
};

export default Main;